import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + "grn";



class Grn {
  create = async (grn: any) => {
    await axios.post<any>(API_URL, grn)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  edit = async (grn: any, code: any) => {
    await axios.put<any>(`${API_URL}/${code}`, grn)
      .catch((e) => {
        throw e;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.grn;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}-not-paid`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.grn;
  };

  getPaidGrn = async () => {
    const response = await axios.get<any>(`${API_URL}-paid`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.grn;
  };

  getNotPaidGrn = async () => {
    const response = await axios.get<any>(`${API_URL}-not-paid`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.grn;
  };

  search = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}-search/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.grn;
  };

  outstandingGrnForSupplier = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}-outstanding-supplier/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.grn;
  };

  getGrnForSupplierPurchaseReturn = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}-supplier-purchase-return/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.grn;
  };

  lock = async (code: any) => {
    try {
      await axios.put(`${API_URL}-locked`, code);
    } catch (e: any) {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    }
  };
}

export default new Grn();
